import { render } from "./IconTrekClass.vue?vue&type=template&id=0088664b"
import script from "./IconTrekClass.vue?vue&type=script&lang=js"
export * from "./IconTrekClass.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__